/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacists } from 'app/entities/pharmacist/pharmacist.reducer';
import { getEntities as getPackageSubscribers } from 'app/entities/package-subscriber/package-subscriber.reducer';
import { getEntities as getHospitalPayments } from 'app/entities/hospital-payment/hospital-payment.reducer';
import { getEntities as getInsuranceClaims } from 'app/entities/insurance-claim/insurance-claim.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-bill-payment.reducer';

export const PharmacyBillPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacists = useAppSelector(state => state.pharmacist.entities);
  const packageSubscribers = useAppSelector(state => state.packageSubscriber.entities);
  const hospitalPayments = useAppSelector(state => state.hospitalPayment.entities);
  const insuranceClaims = useAppSelector(state => state.insuranceClaim.entities);
  const pharmacyBillPaymentEntity = useAppSelector(state => state.pharmacyBillPayment.entity);
  const loading = useAppSelector(state => state.pharmacyBillPayment.loading);
  const updating = useAppSelector(state => state.pharmacyBillPayment.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyBillPayment.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);
  const paymentStatusValues = Object.keys(PaymentStatus);

  const handleClose = () => {
    navigate(`/pharmacy-bill-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyBills({}));
    dispatch(getPharmacists({}));
    dispatch(getPackageSubscribers({}));
    dispatch(getHospitalPayments({}));
    dispatch(getInsuranceClaims({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.tmCursor !== undefined && typeof values.tmCursor !== 'number') {
      values.tmCursor = Number(values.tmCursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.voidedDate !== undefined && typeof values.voidedDate !== 'number') {
      values.voidedDate = Number(values.voidedDate);
    }

    const entity = {
      ...pharmacyBillPaymentEntity,
      ...values,
      pharmacyBill: pharmacyBills.find(it => it.id.toString() === values.pharmacyBill?.toString()),
      collectedBy: pharmacists.find(it => it.id.toString() === values.collectedBy?.toString()),
      subscriber: packageSubscribers.find(it => it.id.toString() === values.subscriber?.toString()),
      hospitalPayment: hospitalPayments.find(it => it.id.toString() === values.hospitalPayment?.toString()),
      claim: insuranceClaims.find(it => it.id.toString() === values.claim?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          paymentStatus: 'ENTERED',
          ...pharmacyBillPaymentEntity,
          pharmacyBill: pharmacyBillPaymentEntity?.pharmacyBill?.id,
          collectedBy: pharmacyBillPaymentEntity?.collectedBy?.id,
          subscriber: pharmacyBillPaymentEntity?.subscriber?.id,
          hospitalPayment: pharmacyBillPaymentEntity?.hospitalPayment?.id,
          claim: pharmacyBillPaymentEntity?.claim?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyBillPayment.home.createOrEditLabel" data-cy="PharmacyBillPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyBillPayment.home.createOrEditLabel">
              Create or edit a PharmacyBillPayment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-bill-payment-id"
                  label={translate('tinyMedicRestApp.pharmacyBillPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.paymentMethod')}
                id="pharmacy-bill-payment-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.transactionDetails')}
                id="pharmacy-bill-payment-transactionDetails"
                name="transactionDetails"
                data-cy="transactionDetails"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.paidAmount')}
                id="pharmacy-bill-payment-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.active')}
                id="pharmacy-bill-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.tmCursor')}
                id="pharmacy-bill-payment-tmCursor"
                name="tmCursor"
                data-cy="tmCursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.timestampentry')}
                id="pharmacy-bill-payment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.microSec')}
                id="pharmacy-bill-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.lastupdated')}
                id="pharmacy-bill-payment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.settledAtHospital')}
                id="pharmacy-bill-payment-settledAtHospital"
                name="settledAtHospital"
                data-cy="settledAtHospital"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.addedByType')}
                id="pharmacy-bill-payment-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.addedByID')}
                id="pharmacy-bill-payment-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.modifiedByType')}
                id="pharmacy-bill-payment-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.modifiedByID')}
                id="pharmacy-bill-payment-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.paymentStatus')}
                id="pharmacy-bill-payment-paymentStatus"
                name="paymentStatus"
                data-cy="paymentStatus"
                type="select"
              >
                {paymentStatusValues.map(paymentStatus => (
                  <option value={paymentStatus} key={paymentStatus}>
                    {translate(`tinyMedicRestApp.PaymentStatus.${paymentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.forCredit')}
                id="pharmacy-bill-payment-forCredit"
                name="forCredit"
                data-cy="forCredit"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.voided')}
                id="pharmacy-bill-payment-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.voidedReason')}
                id="pharmacy-bill-payment-voidedReason"
                name="voidedReason"
                data-cy="voidedReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillPayment.voidedDate')}
                id="pharmacy-bill-payment-voidedDate"
                name="voidedDate"
                data-cy="voidedDate"
                type="text"
              />
              <ValidatedField
                id="pharmacy-bill-payment-pharmacyBill"
                name="pharmacyBill"
                data-cy="pharmacyBill"
                label={translate('tinyMedicRestApp.pharmacyBillPayment.pharmacyBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-payment-collectedBy"
                name="collectedBy"
                data-cy="collectedBy"
                label={translate('tinyMedicRestApp.pharmacyBillPayment.collectedBy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacists
                  ? pharmacists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-payment-subscriber"
                name="subscriber"
                data-cy="subscriber"
                label={translate('tinyMedicRestApp.pharmacyBillPayment.subscriber')}
                type="select"
              >
                <option value="" key="0" />
                {packageSubscribers
                  ? packageSubscribers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-payment-hospitalPayment"
                name="hospitalPayment"
                data-cy="hospitalPayment"
                label={translate('tinyMedicRestApp.pharmacyBillPayment.hospitalPayment')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalPayments
                  ? hospitalPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-payment-claim"
                name="claim"
                data-cy="claim"
                label={translate('tinyMedicRestApp.pharmacyBillPayment.claim')}
                type="select"
              >
                <option value="" key="0" />
                {insuranceClaims
                  ? insuranceClaims.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-bill-payment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyBillPaymentUpdate;
